import React from 'react'

import { Icon } from '../icon/Icon'

export const ToastIcon = (
  props: React.ComponentProps<typeof Icon>
): React.JSX.Element => (
  <Icon size="sm" {...props} className="mr-3 flex-[0_0_auto]" />
)
